import { MoneyBox } from '@apply/components';
import { useExperienceBudget } from '../../../../fields/ExperienceFields';

interface RehabilitationBudgetProps {
    experienceId: string | undefined;
    required?: boolean;
    readOnly?: boolean;
}

export const RehabilitationBudget: React.FC<RehabilitationBudgetProps> = ({ experienceId, required = false, readOnly }) => {
    const label = 'How much did you spend on rehabilitation? ';
    const [budget, set_budget] = useExperienceBudget(experienceId);

    return (
        <>
            <MoneyBox
                id='experienceRehabilitationBudget'
                allowNegative={false}
                value={budget}
                onChange={(value) => {
                    set_budget(value);
                }}
                required={required}
                label={label}
                displayChange={false}
                max={100000000}
                min={0}
                readOnly={readOnly}
            />
        </>
    );
};
